var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2476 8.62381C16.2476 10.4165 15.6657 12.0725 14.6854 13.4161L19.6299 18.3646C20.1182 18.8528 20.1182 19.6456 19.6299 20.1338C19.1417 20.6221 18.3489 20.6221 17.8607 20.1338L12.9161 15.1853C11.5725 16.1696 9.91652 16.7476 8.12381 16.7476C3.63619 16.7476 0 13.1114 0 8.62381C0 4.13619 3.63619 0.5 8.12381 0.5C12.6114 0.5 16.2476 4.13619 16.2476 8.62381ZM8.12381 14.248C11.2288 14.248 13.748 11.7288 13.748 8.62381C13.748 5.5188 11.2288 2.99963 8.12381 2.99963C5.0188 2.99963 2.49963 5.5188 2.49963 8.62381C2.49963 11.7288 5.0188 14.248 8.12381 14.248Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.7e2bba854257d887ff58c3b71b188db4.svg";
export { ForwardRef as ReactComponent };